export const styles = {
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 relative before:absolute before:left-0 before:right-0 before:top-[60px] before:h-[1px] before:bg-gray-200 dark:before:bg-gray-700",
  header: "px-0 py-1",
  title: "text-theme-xl font-semibold text-gray-800 dark:text-white/90 pb-4",
  formContainer:
    "bg-white dark:bg-gray-800 rounded-lg mt-4 overflow-hidden",
  form: "grid grid-cols-1 md:grid-cols-3 gap-6 items-start",
  inputContainer: "col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4",
  label: "text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block",
  input: "w-full px-3 py-2 rounded-md border-gray-300 dark:bg-gray-900 dark:border-gray-700 bg-transparent text-gray-800 dark:text-white/90 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 dark:focus:border-brand-800", // Removed transition-all duration-200
  inputError: "border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10",
  errorText: "text-red-500 dark:text-red-400 text-xs mt-1",
  buttonContainer: "col-span-1 md:col-span-3 p-4 flex justify-end gap-4",
  submitButton:
    "px-6 py-2 text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white rounded-lg hover:bg-[#2779bd] dark:hover:bg-[#335877] transition",
  cancelButton:
    "px-4 py-2 text-sm bg-white text-gray-700 ring-1 ring-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-900 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-gray-700 transition",
};